<script>

import PaginateButton from "@/components/ui/Table/components/PaginateButton.vue";

export default {
    name: "TablePaginate",
    components: {PaginateButton},
    props: {
        page: Number,
        total: Number,
        lastPage: Number,
    },
}
</script>

<template>
<div class="table-paginate">
    <PaginateButton v-if="page !== 1" @click="$emit('change-page', page - 1)">Попередній</PaginateButton>
    <div class="details">{{ page }} з {{ lastPage }}</div>
    <PaginateButton v-if="page !== lastPage" @click="$emit('change-page', page + 1)">Наступний</PaginateButton>
</div>
</template>

<style scoped lang="scss">
.table-paginate {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 12px 24px 16px;

    width: 100%;
    /*height: 64px;*/

    /* Gray/200 */
    border-top: 1px solid #E9EAEB;

    /* Inside auto layout */
    flex: none;
    order: 2;
    align-self: stretch;
    flex-grow: 0;

    .details {
        /* Details */

        margin: 0 auto;

        /* Text sm/Medium */
        font-family: 'Inter',serif;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height, or 143% */

        /* Gray/700 */
        color: #414651;
    }
}
</style>
